import { useState, useEffect } from "react";
import { useOutletContext, Link } from "react-router-dom";
import {Card, CardBody, CardTitle, CardText, CardLink } from "reactstrap";

import { translations } from './../../i18/translations.js';
import { Div } from './../../util/Html.js';
import './GaleryList.css';

const GaleryList = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const RESOURCES_DIR = process.env.REACT_APP_RESOURCES_DIR;
    const {lang} = useOutletContext();
    const [galleries, setGalleries] = useState([]);
    useEffect(() => {
        fetchGalleries();
    }, [lang]);
    const fetchGalleries = async () => {
        try {
            const response = await fetch(`${API_URL}/common/get_galery_list.php`);
            const data = await response.json();
            setGalleries(data);
        } catch (error) {
            console.error("Error fetching galleries:", error);
        }
    };
    return (
            <div className="mbkegy-content">
                <h1 className="mbkegy-content">{translations[lang].galery_list}</h1>
            
                {galleries.map((gallery) => (
                                <Card className="mbkegy-galery">
                                <CardBody>
                                    <CardTitle tag="h5">
                                        {gallery.name}
                                    </CardTitle>
                                </CardBody>
                                <div className="galery-image-list">                            
                                    {gallery.images.map((img) => (
                                                                    <img className="galery-image-list-index" src={`/${RESOURCES_DIR}/galery/${gallery.base_dir}/${gallery.index_dir}/${img}`} />
                                                                ))}
                                </div>
                                <CardBody>
                                    <CardText>
                                        <Div content={gallery.description} /> 
                                        {gallery.image_count > 0
                                                        ? `${gallery.image_count} ${translations[lang].image}`
                                                        : null}
                                    </CardText>
                                    <CardLink href="#">
                                        <Link className="content-view-link galery-link" to={`/GaleryById/${gallery.id}`} >{translations[lang].open_galery} </Link>
                                    </CardLink>
                                </CardBody>
                                </Card>
                                ))}
            
            </div>
            );
};
export default GaleryList;